import { API } from "../../utils/_HttpUtils";
import { user_routes as routes } from "../../constants/api-routes";

const logout = () => new API().send("GET", routes.logout);

export { logout };
